import { useCallback, useEffect, useRef, useState } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import config from "../../config";
import SideMenu from "./sideMenu";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import { tableIcons } from "../../tableIcons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Parser } from "json2csv";
import MaterialTable, { MTableToolbar } from "material-table";
import { TablePagination } from "@material-ui/core";
import { useCountry } from "../../provider/courtryProvider";
import { Card, Button, Alert, theme, Tooltip, message } from "antd";
import CustomTable from "../table";
import { withRouter } from "../../utils/withRouter";
import { useAccess } from "../../provider/AccessProvider";
import { BsInfoCircle } from "react-icons/bs";

const ProductPriceBuldUpdate = (props) => {
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [excelDownloadLoading, setExcelDownloadLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const country = useCountry();
  const {
    token: { colorPrimary },
  } = theme.useToken();
  const [updatedData, setUpdatedData] = useState([]);
  const [uploading, setUploading] = useState(false);
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const taxMaster = shopDetails.taxMaster;
  const ref = useRef();
  const access = useAccess(["bulkUpdatePrice"]);
  const rowTemplate = [
    "productId",
    "productBrand",
    "productName",
    "productMrp",
    "productPrice",
    "inventoryQty",
  ];
  useEffect(() => {
    if (shopDetails) getProductDetails(shopDetails.shopId);
  }, []);
  const getProductDetails = async (shopId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopId,
          type: "getProductDetails",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.limitExceeds && data.status) {
          try {
            var productData = await fetch(data.products);
            productData = await productData.json();
            let sortedArr = productData.sort((a, b) => {
              if (a.productName === b.productName) return 0;
              if (a.productName > b.productName) return 1;
              return -1;
            });
            setProducts(sortedArr);
            setIsLoaded(true);
            return;
          } catch (err) {
            alert("Failed to fetch product details. Please try again");
            return;
          }
        }
        var sortedArr = data.products.sort((a, b) => {
          if (a.productName === b.productName) return 0;
          if (a.productName > b.productName) return 1;
          return -1;
        });
        setProducts(sortedArr);
        setIsLoaded(true);
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const productExcelDownload = () => {
    setExcelDownloadLoading(true);
    var filteredProd = products
      .filter((data) => data.frequentPriceChange)
      .map((data) => {
        const variants = [data.size, data.unitOfMeasurment];
        const commaJoined = variants.filter((variant) => variant).join(",");
        const productName = `${data.productName}${
          (data.unitOfMeasurment || data.size) && `-(${commaJoined})`
        }`;
        return {
          productId: data.productId,
          productBrand: data.productBrand,
          productName: productName,
          inventoryQty: data.inventoryQty,
          productMrp: data.productMrp,
          productPrice: data.productPrice,
        };
      });
    filteredProd.sort((a, b) => a.productName.localeCompare(b.productName));
    if (filteredProd.length === 0)
      return alert(
        "No products found. Please make sure that you have checked the frequent price change field in inventory."
      );
    var csvParser = new Parser();
    const csv = csvParser.parse(filteredProd);

    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");

    var url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", "Products.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setExcelDownloadLoading(false);
  };

  const getExcelData = (e) => {
    let fileObj = e.target.files[0];
    ExcelRenderer(fileObj, (err, data) => {
      if (err) {
        console.log("Error", err);
      } else {
        if (rowTemplate.length !== data.rows[0].length) {
          errorPopUp();
          return;
        }
        for (var i = 0; i < data.rows[0].length; i++) {
          if (data.rows[0].includes(rowTemplate[i])) {
            continue;
          }
          errorPopUp();
          return;
        }
        let arr = [];
        for (var i = 1; i < data.rows.length; i++) {
          let rowArr = data.rows[i];
          let headingArr = data.rows[0];
          let count = 0;
          if (rowArr.length <= 0) continue;
          let obj = {
            productId: "",
            productBrand: "",
            productName: "",
            productMrp: "",
            productPrice: "TBD",
            inventoryQty: 0,
          };
          var res = rowArr.reduce((result, field, index) => {
            result[headingArr[index]] = field;
            return result;
          }, {});
          console.log("Res Arr", res);
          arr.push(res);
        }
        setUpdatedData(arr);
      }
    });
  };

  const errorPopUp = () => {
    alert(
      "Invalid Excel Sheet, Please Download the Excel Template given in this page add your products and upload again."
    );
    setUpdatedData([]);
    ref.current.value = "";
  };

  const taxableValueFunc = useCallback(
    (productPrice = 0, productTax = 0, count, taxIncExc = "", isTax) => {
      let result = 0;
      if (taxIncExc === "inclusive") {
        result =
          (productPrice / (100 + parseInt(productTax || 0))) *
          parseFloat(count || 0) *
          100;
      } else if (taxIncExc === "exclusive") {
        result = productPrice * parseFloat(count || 0);
      } else {
        result = productPrice * count;
      }

      console.log("result1111", result);
      return result;
    },
    []
  );

  const taxTypeFunc = useCallback(
    (taxableValue, seletedTax, isTax) => {
      const customTaxValue = {};

      seletedTax?.taxType?.forEach((tax) => {
        const taxTypeName =
          customTaxType.find((customTax) => customTax.taxId === tax)?.taxName ||
          tax;
        customTaxValue[taxTypeName] =
          (customTaxValue[taxTypeName] || 0) +
          parseFloat(
            taxableValue * (parseFloat(seletedTax[taxTypeName] || 0) / 100)
          );
      });

      const sumOfTax = Object.values(customTaxValue).reduce(
        (acc, cur) => acc + cur,
        0
      );
      const itemTotal = parseFloat(taxableValue) + sumOfTax;
      return {
        ...customTaxValue,
        taxType: Object.keys(customTaxValue),
        itemTotal,
        taxableValue,
        totalBeforeTax: taxableValue,
      };
    },
    [customTaxType]
  );

  const getTaxableValueAndTaxs = useCallback(
    (product, price = 0, quantity = 0) => {
      let taxableValue = 0;
      let totalTaxPercentage = 0;
      let taxs = {};
      let newProduct = {};
      let itemTotal = 0;

      if (
        product.taxId &&
        product.taxId !== "Select Tax" &&
        product.taxIncExc !== "Inclusive/Exclusive"
      ) {
        let selectedTax = taxMaster.find(
          (item) => item.taxId === product.taxId
        );
        totalTaxPercentage = selectedTax?.taxType?.reduce((acc, curr) => {
          const taxTypeName =
            customTaxType.find((customTax) => customTax.taxId === curr)
              ?.taxName || curr;
          return acc + parseFloat(selectedTax[taxTypeName] || 0);
        }, 0);
        taxableValue = taxableValueFunc(
          price,
          totalTaxPercentage,
          quantity,
          product.taxIncExc
        );
        taxs = taxTypeFunc(taxableValue, selectedTax);
        itemTotal = taxs.itemTotal;
      } else {
        itemTotal = price * parseFloat(quantity);
      }

      let discount = 0;
      newProduct = {
        ...product,
        ...taxs,
        count: quantity,
        productPrice: price,
        taxType: taxs.taxType ? taxs.taxType : [],
        totalTax: totalTaxPercentage,
        itemTotal:
          product.discountType === "flat"
            ? itemTotal - discount * quantity
            : itemTotal - discount,
      };
      return newProduct;
    },
    [taxMaster, taxableValueFunc, taxTypeFunc, customTaxType]
  );

  function isNumeric(str) {
    return !isNaN(str) && !isNaN(parseFloat(str));
  }

  const uploadProduct = async () => {
    setUploading(true);
    new Promise((resolve, reject) => {
      updatedData.forEach((item, index, arr) => {
        if (!isNumeric(item.inventoryQty)) {
          reject(
            "Inventory quantity should be a number for Item Number(s):" +
              (index + 1)
          );
        }
        if (item.productMrp) {
          if (!isNumeric(item.productMrp)) {
            reject(
              `Product mrp should be a number for Item Number(s): ${index + 1}`
            );
          }
        }
        if (!isNumeric(item.productPrice)) {
          reject(
            `Selling price should be a number for Item Number(s): ${index + 1}`
          );
        }
        if (item.productMrp) {
          const product = products.find(
            (product) => product.productId === item.productId
          );
          if (product.taxId && product.taxIncExc) {
            const result = getTaxableValueAndTaxs(
              product,
              item.productPrice,
              1
            );
            if (item.productMrp < result.itemTotal) {
              reject(
                `Selling price exceeding the MRP after applying tax for Item Number(s):${
                  index + 1
                }`
              );
            }
          }
        }
        if (updatedData.length - 1 === index) {
          resolve(arr);
        }
      });
    })
      .then(async (res) => {
        await Promise.all([
          fetch(`${config.newApiGateway}/products/bulkPriceUpdate`, {
            method: "POST",
            body: JSON.stringify(updatedData),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          }),
        ])
          .then(([res]) => Promise.all([res.json()]))
          .then(([data]) => {
            alert("Product updated successfully");
            setUpdatedData([]);
            setUploading(false);
            props.history.push("/dashboard/shop-items");
          })
          .catch((err) => {
            console.log("err", err);
            setUploading(false);
            alert("failed, try again");
          });
      })
      .catch((err) => {
        message.error(err);
        setUploading(false);
      });
  };

  const columns = [
    {
      dataIndex: "productId",
      title: "Id",
    },
    {
      dataIndex: "productBrand",
      title: "Product Brand",
    },
    {
      dataIndex: "productName",
      title: "Product Name",
    },
    {
      dataIndex: "inventoryQty",
      title: "Inventory Quantity",
    },
    {
      dataIndex: "productMrp",
      title: `Product MRP(${country.CurrencySymbol})`,
    },
    {
      dataIndex: "productPrice",
      title: `Product Price(${country.CurrencySymbol})`,
    },
  ];

  if (!access.bulkUpdatePrice(false)) {
    return (
      <Alert
        style={{
          padding: "20px",
          textAlign: "center",
        }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }

  return (
    <>
      <div>
        <div>
          <div>
            <Card
              bodyStyle={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div>
                <Button type="primary" ghost onClick={productExcelDownload}>
                  Download all products
                </Button>
                <Tooltip title="Do not make any changes to the product ID or product name, as this will not update the relevant product.">
                  <BsInfoCircle
                    size={18}
                    color={colorPrimary}
                    style={{ marginLeft: "10px", verticalAlign: "text-top" }}
                  />
                </Tooltip>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                }}
              >
                <input
                  type="file"
                  ref={ref}
                  style={{
                    width: 200,
                  }}
                  onChange={getExcelData}
                  accept=".csv, text/csv,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />{" "}
                <Button
                  type="dashed"
                  disabled={uploading}
                  onClick={uploadProduct}
                >
                  Upload
                </Button>
              </div>
            </Card>

            <div style={{ marginTop: "20px" }}>
              <CustomTable
                columns={columns}
                title={"Shop Items"}
                data={updatedData}
                style={{
                  minHeight: "calc(100vh - 365px)",
                }}
                emptyContainerStyle={{
                  minHeight: "calc(100vh - 300px)",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ProductPriceBuldUpdate);
